<template>
    <div class="login-body">
        <div class="login-container">
            <div class="login-form">
                <div class="login-form-logo">
                    <img src="/logo.png">
                </div>
                <b-form @submit.prevent="doLogin">
                    <h5>Log In</h5>
                    <b-form-group label="Username">
                        <b-form-input v-model="input.username" placeholder="username" required />
                    </b-form-group>
                    <b-form-group label="Password" class="password-form-group">
                        <b-form-input v-model="input.password" placeholder="password" :type="passwordType" required />
                        <i :class=iconName @click="changePasswordType()" />
                    </b-form-group>
                    <b-button type="submit" block variant="primary" :disabled="isLoggingIn">
                        {{ isLoggingIn ? "Logging in..." : "Log In"}}
                    </b-button>
                    <div class="login-error-wrapper mt-3" v-if="errorMessage != ''">
                        <div class="text-danger">{{ errorMessage }}</div>
                    </div>
                </b-form>
                <p class="login-copyright">&copy; 2020 PT WESP Indonesia.</p>
            </div>
            <div class="login-content">
                <div class="login-content-wrapper">
                    <div class="login-sm-hidecontent">
                        <h1>WESPI Tracken</h1>
                        <p>Engine Tracker Management System</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data() {
        return {

            input: {
                username: '',
                password: ''
            },

            isLoggingIn: false,
            errorMessage: "",

            passwordType: 'password',
            iconName: 'fa fa-eye-slash',
            oldPasswordType: 'password',
            oldIconName: 'fa fa-eye-slash',
            newPasswordType: 'password',
            newIconName: 'fa fa-eye-slash',
            confirmPasswordType: 'password',
            confirmIconName: 'fa fa-eye-slash',

        }
    },
    methods: {

        doLogin() {

            let payload = new FormData()
            payload.append("username", this.input.username)
            payload.append("password", this.input.password)

            this.isLoggingIn = true
            this.errorMessage = ""
            this.$axios.post(`auth/login`, payload).then(response => {

                let data = response.data

                if(localStorage.getItem("version") === null) {
                    localStorage.setItem("reload", 1)
                    localStorage.setItem("version", data.version)
                }
                else {

                    if(localStorage.getItem("version") !== data.version) {
                        localStorage.setItem("reload", 1)
                    }

                    localStorage.setItem("version", data.version)

                }

                localStorage.setItem("fullname", data.fullname)
                localStorage.setItem("roleId", data.roleId)
                localStorage.setItem("roleName", data.roleName)
                localStorage.setItem("token", "Bearer " + data.token)
                localStorage.setItem("wilayahName", data.wilayahName)
                localStorage.setItem("wilayahId", data.wilayahId)

                this.$axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
                this.$router.push("/landing-page")

            })
            .catch(error => {
                this.$helper.toastError(this, error.response.data.message)
            })
            .finally(() => {
                this.isLoggingIn = false
            })

        },

        changePasswordType() {

            if(this.passwordType == 'password' && this.iconName == 'fa fa-eye-slash') {
                this.passwordType = 'text'
                this.iconName = 'fa fa-eye'
            }
            else {
                this.passwordType = 'password'
                this.iconName = 'fa fa-eye-slash'
            }

        },

    }
}

</script>
